import { createContext, useContext } from 'react';

export interface ActionsContextValue {
	isRenewDrawerOpen: boolean;
	isTransferDialogOpen: boolean;
	toggleRenewDrawer: () => void;
	toggleTransferDialog: () => void;
}

export const actionsContext = createContext<ActionsContextValue | null>(null);

export const useActionsContext = () => {
	const context = useContext(actionsContext);

	if (!context) {
		throw new Error(
			'useActionsContext must be used withoin an actionsContext.Provider',
		);
	}

	return context;
};
